import { createReducer } from "reduxsauce";
import _ from "lodash";
import UIDs from "../../../UIDs";

import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/me/WithdrawActionTypes";
import { ActionTypes as EditBankAccountActionTypes } from "../../actionTypes/screens/me/EditBankAccountActionTypes";
import MyWalletService from "../../../services/screens/me/MyWalletService";
import AsyncActionReducers from "../../AsyncActionReducers";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            MyWalletService.loadWithdrawView(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    verifyCodeAsync: vo => {
        return dispatch => {
            dispatch({ type: ActionTypes.VERIFY_CODE_ASYNC, vo });

            MyWalletService.verifyCode(
                vo,
                response => {
                    dispatch(Actions.verifyCodeSuccess(response, vo));
                },
                error => {
                    dispatch(Actions.verifyCodeFailure(error));
                }
            );
        };
    },

    verifyCodeSuccess: (data, vo) => ({
        type: ActionTypes.VERIFY_CODE_SUCCESS,
        parentType: ActionTypes.VERIFY_CODE_ASYNC,
        data,
        vo,
    }),

    verifyCodeFailure: error => ({
        type: ActionTypes.VERIFY_CODE_FAILURE,
        parentType: ActionTypes.VERIFY_CODE_ASYNC,
        error,
    }),

    sendVerifyCodeAsync: vo => {
        return dispatch => {
            dispatch({ type: ActionTypes.SEND_VERIFY_CODE_ASYNC, vo });

            MyWalletService.sendVerifyCode(
                vo,
                response => {
                    dispatch(Actions.sendVerifyCodeSuccess(response));
                },
                error => {
                    dispatch(Actions.sendVerifyCodeFailure(error));
                }
            );
        };
    },

    sendVerifyCodeSuccess: data => ({
        type: ActionTypes.SEND_VERIFY_CODE_SUCCESS,
        parentType: ActionTypes.SEND_VERIFY_CODE_ASYNC,
        postReducer: sendVerifyCodeSuccessPostReducer,
        data
    }),

    sendVerifyCodeFailure: error => ({
        type: ActionTypes.SEND_VERIFY_CODE_FAILURE,
        parentType: ActionTypes.SEND_VERIFY_CODE_ASYNC,
        error
    }),

    setState: (vo) => ({
        type: ActionTypes.SET_STATE,
        vo
    }),

    saveWithdrawalAsync: vo => {
        return dispatch => {
            dispatch({ type: ActionTypes.SAVE_WITHDRAWAL_ASYNC, vo });

            MyWalletService.saveWithdrawal(
                vo,
                response => {
                    dispatch(Actions.saveWithdrawalSuccess(response));
                },
                error => {
                    dispatch(Actions.saveWithdrawalFailure(error));
                }
            );
        };
    },

    saveWithdrawalSuccess: data => ({
        type: ActionTypes.SAVE_WITHDRAWAL_SUCCESS,
        parentType: ActionTypes.SAVE_WITHDRAWAL_ASYNC,
        data,
    }),

    saveWithdrawalFailure: error => ({
        type: ActionTypes.SAVE_WITHDRAWAL_FAILURE,
        parentType: ActionTypes.SAVE_WITHDRAWAL_ASYNC,
        error,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    bankAccounts: null,
    balance: 0,
    availableBalance: 0,
    baseCurrency: null,
    amountApplied: null,
    countDownStarted: null,
    isOpen: false,
    countDown: null,
    showCodeFailureMsg: false,
    bankAccountId: null,
    verificationCode: null  
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    const { bankAccount } = data;
    if (bankAccount) {
        const newBankAccounts = _.clone(state.bankAccounts || []);
        const index = newBankAccounts.findIndex(item => item.id === bankAccount.id);
        if (index > -1) {
            newBankAccounts[index] = bankAccount;
        } else {
            newBankAccounts.push(bankAccount);
        }
        return { 
            ...state,
            bankAccounts: newBankAccounts
        };
    } else {
        return { 
            ...state, 
            balance: data.amounts.balance, 
            availableBalance: data.amounts.availableBalance,
            baseCurrency: data.amounts.baseCurrency,
            bankAccounts: data.bankAccounts,
            bankAccountId: data.bankAccounts?.[0]?.id
        };
    }
};

const deleteBankAccountSuccessPostReducer = (state, { vo }) => {
    const { bankAccounts, bankAccountId } = state;
    const newBankAccounts = _.clone(bankAccounts);
    let index = newBankAccounts.length - 1;
    while (index >= 0) {
        if (newBankAccounts[index].id === vo.id)
        newBankAccounts.splice(index, 1);
        index -= 1;
    }
    if (bankAccountId === vo.id) {
        return { ...state, bankAccounts: newBankAccounts, bankAccountId: newBankAccounts?.[0]?.id };
    }
    return { ...state, bankAccounts: newBankAccounts };
};

const sendVerifyCodeSuccessPostReducer = state => {
    return { ...state, countDownStarted: true, showCodeFailureMsg: false };
};

const setStateReducer = (state, { vo }) => {
    return { ...state, ...vo };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.VERIFY_CODE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.VERIFY_CODE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.VERIFY_CODE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SEND_VERIFY_CODE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SEND_VERIFY_CODE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SEND_VERIFY_CODE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_WITHDRAWAL_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_WITHDRAWAL_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_WITHDRAWAL_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SET_STATE]: setStateReducer,
    [EditBankAccountActionTypes.SAVE_BANK_ACCOUNT_SUCCESS]: loadScreenViewSuccessPostReducer,    
    [EditBankAccountActionTypes.DELETE_BANK_ACCOUNT_SUCCESS]: deleteBankAccountSuccessPostReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.me.withdraw, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
